import loadable from '@loadable/component';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import useGetHook from '../../customHooks/useGetHook';
import APIS from '../../constant/Endpoint';
const QuickEmailComponent = loadable(
  () => import('../../components/QuickEmail/QuickEmail')
);

const QuickEmail = () => {
  const { refetch } = useGetHook({
    url: APIS.SENDER_EMAIL,
    queryKey: ['emails'],
    params: {
      is_default: true,
    },
  });
  return (
    <>
      <div className={tw`pb-2`}>
        <h1 className={tw`text-lg font-semibold`}> Quick Email</h1>
      </div>
      <QuickEmailComponent refetch={refetch} />
    </>
  );
};

export default QuickEmail;
